module.exports = __webpack_public_path__ + "img/2012-08-18 17.19.06.85a5021d.jpg";